import _isEmpty from 'lodash/isEmpty'

import SectionBanner from './SectionBanner'
import SectionOurService from './SectionOurService'
import SectionWhyUs from './SectionWhyUs'
import SectionPromotion from './SectionPromotion'
import SectionWorkStep from './SectionWorkStep'
import SectionPortfolio from './SectionPortfolio'
import SectionOurCustomer from './SectionOurCustomer'
import SectionBusiness from './SectionBusiness'

import Styled from './styled'

export default function Home({ data, banners, portfolios, promotions }) {
  return (
    <Styled>
      <div className="bg-block-1">
        <div className="carousel-container">
          <SectionBanner banners={banners} />
        </div>

        <div className="container">
          <div className="our-service-container">
            <SectionOurService data={data?.categorySection} />
          </div>
        </div>
      </div>

      <div className="bg-block-2">
        <div className="promotion-container">
          {!_isEmpty(promotions) && (
            <div className="container">
              <SectionPromotion promotions={promotions} />
            </div>
          )}

          <div className="why-us-container">
            <div className="container">
              <SectionWhyUs data={data?.why24fixSection} />
            </div>
          </div>
        </div>

        <div className="portfolio-container">
          <SectionPortfolio portfolios={portfolios} />
        </div>

        {/* <div className="review-container">
          <div className="desktop">
            <SectionCustomerReview data={data?.reviewSection} />
          </div>
          <div className="mobile">
            <div className="container">
              <SectionCustomerReview data={data?.reviewSection} />
            </div>
          </div>
        </div> */}

        <div className="work-container">
          <div className="container">
            <SectionWorkStep data={data?.howWeWorkSection} />
          </div>
        </div>
      </div>

      <div className="customer-container">
        <div className="container">
          <SectionOurCustomer data={data?.ourClientSection} />
        </div>
      </div>

      <div className="background-block">
        <div className="container">
          <div className="business-container">
            <SectionBusiness data={data?.b2bSection} />
          </div>
        </div>

        {/* <div className="invite-container">
          <div className="desktop">
            <div className="container">
              <SectionInvite />
            </div>
          </div>
          <div className="mobile">
            <div className="container">
              <SectionInvite />
            </div>
          </div>
        </div> */}
      </div>
    </Styled>
  )
}
